// extracted by mini-css-extract-plugin
export default {"wrapper":"StaticGoogleMap_wrapper__8qAvF","map":"StaticGoogleMap_map__GiOf9","map_invisible":"StaticGoogleMap_map_invisible__JJzXU"};